import { render, staticRenderFns } from "./catalog.cattle.io.app.vue?vue&type=template&id=3110bd1e&scoped=true&"
import script from "./catalog.cattle.io.app.vue?vue&type=script&lang=js&"
export * from "./catalog.cattle.io.app.vue?vue&type=script&lang=js&"
import style0 from "./catalog.cattle.io.app.vue?vue&type=style&index=0&id=3110bd1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110bd1e",
  null
  
)

export default component.exports